import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { wishedNfts } from "../../API/functions";

export const useWishedNft = () => {
  const queryClient = useQueryClient()
  const { mutate,isPending } = useMutation({
    mutationFn: (vars) => wishedNfts(vars.nftId, vars.wallet_address, vars.action), 
    onSuccess: (result) => {
      queryClient.invalidateQueries(["getLikedNft"]);
      toast.success(result.message);
    },
  });

  return { mutate ,isPending};
};
